import sendNetworkReq from '@/utils/sendNetworkReq';

export const GET_ALL_CATEGORIES = 'GET_ALL_CATEGORIES';

export const getAllCategories = () => {
	return async (dispatch) => {
		const { categories } = await sendNetworkReq({
			method: 'GET',
			url: 'categories/all',
			auth: false,
		});
		dispatch({
			type: GET_ALL_CATEGORIES,
			payload: categories || [],
		});
	};
};
